import { twoItemLabel } from 'App/data-export/valueTypeRenderers/renderers/_utils/labelHelpers'
import { makeNumberRenderer } from 'App/data-export/valueTypeRenderers/renderers/_utils/makeNumberRenderer'
import type { valueTypeRenderers } from 'App/data-export/valueTypeRenderers/valueTypeRenderers'
import type { TLngLat } from 'App/Map/types'
import { translate } from 'i18n/i18n'
import { fieldAssetStore } from 'stores/fieldAssetStore/fieldAssetStore'
import { getCropNameFromId } from 'utils/getCropNameFromId'
import { unitConverter } from 'utils/unitConverter/unitConverter'

export const fruitGrowth: typeof valueTypeRenderers.fruitGrowth = {
  label: () => unitConverter.fruitGrowth().titleWithoutUnit(),
  point: ({ fieldAssetItem }) => {
    const cropId =
      fieldAssetStore.getState()?.properties?.[Number(fieldAssetItem.propertyId)]?.points?.[
        fieldAssetItem.id as TLngLat
      ]?.configuration.fruitDendrometerCropId ?? null

    const { shortTitle, suffix } = unitConverter.fruitGrowth()

    return makeNumberRenderer({
      baseLabel: twoItemLabel([
        translate.phrases.templates('{{labelA}} - {{labelB}}', {
          labelA: shortTitle(),
          labelB: getCropNameFromId(Number(cropId)),
        }),
        suffix(),
      ]),
      render: (n) => unitConverter.fruitGrowth(n).valueAsString(),
    })
  },
}
